import { render, staticRenderFns } from "./detail-component-contactdetails.vue?vue&type=template&id=9ba494ea&scoped=true"
import script from "./detail-component-contactdetails.vue?vue&type=script&lang=ts"
export * from "./detail-component-contactdetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba494ea",
  null
  
)

export default component.exports